import { Thesaurus } from "@skinsoft/types";
import { SEARCH_TYPES } from "@skinsoft/const";

import { ThesaurusDataStore } from "@skinsoft/entity";
import { CACHE_KEYS, ThesaurusOfflineDataFetcher } from "@skinsoft/offline";
import { EntitySyncDownHandler } from "../../entity-sync-down-handler";

declare const config
const SEARCH_PAGE_SIZE = config.syncDownPageSize.thesaurus ?? config.syncDownPageSize.default

export class ThesaurusSyncDownHandler extends EntitySyncDownHandler<Thesaurus, Thesaurus, Thesaurus> {
    private static instance: ThesaurusSyncDownHandler = null as any

    public static getInstance() {
        if (!ThesaurusSyncDownHandler.instance) {
            ThesaurusSyncDownHandler.instance = new ThesaurusSyncDownHandler()
        }

        return ThesaurusSyncDownHandler.instance
    }

    public static install(Vue) {
        ThesaurusSyncDownHandler.getInstance()
    }

    constructor() {
        super(
            [SEARCH_TYPES.thesaurus],
            ThesaurusDataStore.getInstance(),
            new ThesaurusOfflineDataFetcher(CACHE_KEYS.Thesaurus),
            CACHE_KEYS.Thesaurus,
            SEARCH_PAGE_SIZE
        )
    }
}